import { Link } from "@tanstack/react-router"
import { ArrowUp, Globe, ShieldCheck } from "lucide-react"

export function Footer() {
  const currentYear = new Date().getFullYear()

  const handleScrollToTop = () => {
    const mainEl = document.querySelector("main")
    if (mainEl && mainEl.scrollTop > 0) {
      mainEl.scrollTo({ top: 0, behavior: "smooth" })
    }
    window.scrollTo({ top: 0, behavior: "smooth" })
  }

  const handleScrollTo = (id: string) => {
    const el = document.querySelector(id)
    if (el) {
      el.scrollIntoView({ behavior: "smooth" })
    }
  }

  return (
    <footer className="w-full mt-auto bg-gradient-to-t from-[#fef3c7]/90 via-[#fef3c7]/55 to-[#fef3c7]/25 dark:from-slate-950 dark:via-slate-950/80 dark:to-slate-900 border-t border-amber-200/60 dark:border-slate-800 relative overflow-hidden">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center px-6 pt-[15px] pb-10 sm:pb-12 max-w-7xl xl:max-w-[clamp(1280px,92vw,1440px)] 2xl:max-w-[clamp(1280px,92vw,1560px)] mx-auto gap-8 lg:px-8 relative z-10">
        
        {/* Brand Block */}
        <div className="flex flex-col gap-3 max-w-md">
          <Link to="/" className="font-sans text-2xl font-black text-slate-900 dark:text-white select-none flex items-center gap-1 group w-fit">
            <span className="text-primary transition-transform duration-300 group-hover:scale-110">E</span>NGA
          </Link>
          <p className="text-slate-700 dark:text-slate-300 text-xs md:text-sm leading-relaxed">
            The world&apos;s most intelligent B2B trade platform for automated procurement, verified sourcing, and dispute-free milestone escrow.
          </p>
          <div className="flex items-center gap-3 text-xs font-medium text-slate-600 dark:text-slate-400 pt-0.5">
            <div className="flex items-center gap-1.5">
              <ShieldCheck className="size-3.5 text-primary" />
              <span>100% Escrow Protected</span>
            </div>
            <span>•</span>
            <div className="flex items-center gap-1.5">
              <Globe className="size-3.5 text-primary" />
              <span>Pan-India Verified</span>
            </div>
          </div>
        </div>

        {/* Navigation & Back to Top Column */}
        <div className="flex flex-col md:items-end gap-5 w-full md:w-auto">
          {/* <div className="flex flex-wrap gap-x-6 gap-y-2 items-center text-sm font-semibold text-slate-800 dark:text-slate-200">
            <button
              onClick={() => handleScrollTo("#how-it-works")}
              className="hover:text-primary transition-colors cursor-pointer"
            >
              How it works
            </button>
            <Link
              to="/signup"
              search={{ role: "buyer" }}
              className="hover:text-primary transition-colors cursor-pointer"
            >
              For Buyers
            </Link>
            <Link
              to="/signup"
              search={{ role: "seller" }}
              className="hover:text-primary transition-colors cursor-pointer"
            >
              For Sellers
            </Link>
            <Link
              to="/explore/suppliers"
              className="hover:text-primary transition-colors cursor-pointer"
            >
              Explore Sourcing
            </Link>
          </div> */}

          <div className="flex items-center justify-between md:justify-end gap-6 w-full text-xs text-slate-600 dark:text-slate-400">
            <span>&copy; {currentYear} ENGA Inc. All rights reserved.</span>
            <button
              onClick={handleScrollToTop}
              className="flex items-center gap-1.5 hover:text-primary text-slate-700 dark:text-slate-300 transition-colors cursor-pointer font-semibold group"
            >
              <span>Back to top</span>
              <ArrowUp className="size-3.5 text-primary transition-transform duration-200 group-hover:-translate-y-0.5" />
            </button>
          </div>
        </div>

      </div>
    </footer>
  )
}
